<template>
  <div>
    <StartNavbar />

    <b-container>
      <b-row align-v="center" class="content-height">
        <b-col cols="12" md="5" lg="6" order="2" order-md="1" class="px-3">
          <img src="@/assets/DigiRoll_Logo.png" class="w-100 mb-3"/>
          <h3 class="mb-3">Der digitale Rollator als Motor sozialer Inklusion</h3>

          <a href="https://digi-roll.de/" target="_blank" class="btn btn-primary mb-5">Mehr erfahren</a>

          
        </b-col>

        <b-col cols="12" md="7" lg="6" order="1" order-md="2">
          <b-card class="my-3" no-body>
            <b-tabs card>
              <b-tab title="Anmelden" active>
                <b-card-text>
                  <Anmelden />
                </b-card-text>
              </b-tab>
              <!-- <b-tab title="Registrieren">
                <b-card-text>
                  <Registrieren />
                </b-card-text>
              </b-tab> -->
            </b-tabs>
          </b-card>
        </b-col>
      </b-row>
    </b-container>

    <b-row class="footer-height">
      <b-col class="p-0">
        <b-container>
          <b-row class="py-3 mt-5" align-v="center">
            <b-col cols="6" lg="3" class="mb-3"><a href="https://www.bmbf.de/" target="_blank"><img src="@/assets/partner_logos/bmbf_logo.jpg" class="w-100"/></a></b-col>
            <b-col cols="6" lg="2" class="mb-3"><a href="https://www.htwsaar.de/" target="_blank"><img src="@/assets/partner_logos/htw_Logo_LA.png" class="w-100"/></a></b-col>
            <b-col cols="6" lg="3" class="mb-3"><a href="http://www.igft-institut.de/" target="_blank"><img src="@/assets/partner_logos/IGFT_Logo-Fertig.jpg" class="w-100"/></a></b-col>
            <b-col cols="6" lg="4" class="mb-3"><a href="https://1aconnect.de/" target="_blank"><img src="@/assets/partner_logos/1A_Logo_light.png" class="w-100"/></a></b-col>
          </b-row>
        </b-container>
        <div class="bg-primary text-white py-3">
          <b-container>
            <a href="https://www.htwsaar.de/impressum-und-datenschutz" class="text-white">Impressum und Datenschutz</a>
          </b-container>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import StartNavbar from './StartNavbar'
import Anmelden from '@/components/Benutzer/Content/Anmelden'
// import Registrieren from '@/components/Benutzer/Content/Registrieren'

export default {
  name: 'Start',
  components: {
    StartNavbar,
    Anmelden,
    // Registrieren
  }
}
</script>
